import { createServerFn } from "@tanstack/react-start";
import { logError, logInfo } from "@/lib/structured-log";
import type {
  MessageListResponse,
  ListDealMessagesApiWorkspacesWorkspaceIdCampaignsCampaignIdDealsDealIdMessagesGetParams,
} from "@/lib/api/generated";
import { listDealMessagesApiWorkspacesWorkspaceIdCampaignsCampaignIdDealsDealIdMessagesGet } from "@/lib/api/generated/campaigns/campaigns";

export const listDealMessagesServer = createServerFn({ method: "GET" })
  .validator(
    (data: {
      workspaceId: string;
      campaignId: string;
      dealId: string;
      params?: ListDealMessagesApiWorkspacesWorkspaceIdCampaignsCampaignIdDealsDealIdMessagesGetParams;
    }) => data,
  )
  .handler(async ({ data }): Promise<MessageListResponse> => {
    logInfo("deals.messages.list.started", {
      workspace_id: data.workspaceId,
      campaign_id: data.campaignId,
      deal_id: data.dealId,
      page: data.params?.page,
      page_size: data.params?.page_size,
    });

    try {
      const response =
        await listDealMessagesApiWorkspacesWorkspaceIdCampaignsCampaignIdDealsDealIdMessagesGet(
          data.workspaceId,
          data.campaignId,
          data.dealId,
          data.params,
        );

      if (response.status !== 200) {
        logError("deals.messages.list.failed", {
          status: response.status,
          workspace_id: data.workspaceId,
          campaign_id: data.campaignId,
          deal_id: data.dealId,
        });
        throw new Error(`Failed to list deal messages: ${response.status}`);
      }

      logInfo("deals.messages.list.completed", {
        total: response.data.total,
        page: response.data.page,
        total_pages: response.data.total_pages,
      });
      return response.data;
    } catch (error) {
      logError("deals.messages.list.error", {
        error: error instanceof Error ? error.message : "unknown-error",
        workspace_id: data.workspaceId,
        campaign_id: data.campaignId,
        deal_id: data.dealId,
      });
      throw error;
    }
  });
